import { ShoppingBag } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { DetailDialog, DetailRow } from "@/components/ui/detail-dialog";
import { UserName } from "@/components/common/EntityName";
import { fmtCurrency, fmtRelativeTime } from "@/lib/utils";
import type { Product } from "@/lib/api/types";

export function ProductDetailDialog({ product, onClose }: { product: Product | null; onClose: () => void }) {
  return (
    <DetailDialog
      open={product !== null}
      onClose={onClose}
      icon={ShoppingBag}
      title={product?.name || "Product"}
      subtitle={product ? fmtCurrency(product.price) : undefined}
    >
      {product && (
        <>
          {product.imageUrl && (
            <div className="py-3">
              <img src={product.imageUrl} alt={product.name} className="h-40 w-full rounded-xl border border-border object-cover" />
            </div>
          )}
          <DetailRow label="Price" value={fmtCurrency(product.price)} />
          <DetailRow label="Stock" value={product.stock} />
          <DetailRow
            label="Active"
            value={<Badge variant={product.isActive ? "success" : "destructive"}>{product.isActive ? "Active" : "Inactive"}</Badge>}
          />
          <DetailRow label="Seller" value={<UserName id={product.sellerId} />} />
          {product.rating != null && <DetailRow label="Rating" value={product.rating.toFixed(1)} />}
          {product.description && (
            <DetailRow label="Description" value={<span className="line-clamp-5 text-left">{product.description}</span>} />
          )}
          <DetailRow label="Created" value={fmtRelativeTime(product.createdAt)} />
          <DetailRow label="Product ID" value={<span className="font-mono text-xs">{product.id}</span>} />
        </>
      )}
    </DetailDialog>
  );
}
